import React from "react";
import { Router, Switch, Route, Redirect } from "react-router-dom";
import routes from './Config'
import createBrowserHistory from "history/createBrowserHistory";
const history = createBrowserHistory();

const RouteWithSubRoutes = route => (
  <Route
    path={route.path}
    render={props => (
      // pass the sub-routes down to keep nesting
      <route.component {...props} routes={route.routes} />
    )}
  />
);

const RouteConfig = (
  <Router history={history}>
    <Switch>
      {routes.map((route, i) => (
        <RouteWithSubRoutes key={i} {...route}/>
      ))}
      <Redirect from="" to="/login" />
    </Switch>
  </Router>
);

export default RouteConfig;



// WEBPACK FOOTER //
// ./src/router/index.js